import React from "react";
import $ from "jquery";
import DataCatalogueLanding from "./components/DataCatalogue/DataCatalogueLanding";
import IndividualPage from "./components/Datasets/AllDataSets/Individual/IndividualPage";
import PublishLineage from "./components/Datasets/PublishLineage/PublishLineage";
import AddNewLineage from "./components/AddNewLineage/AddNewLineage";
import CatalogContent from "./utils/ReUsableComponents/CatalogContent";
import MetricDetailsPage from './components/metricstore/MetricDetailsPage/MetricDetailsPage'

window.jQuery = $;
window.$ = $;
global.jQuery = $;


const NotAuthorized = React.lazy(() =>
  import("./utils/ReUsableComponents/NotAuthorized")
);

const JobIndividualPage = React.lazy(() =>
  import("./components/JobCatalogue/JobIndividualPage")
);

const DatasetsPageContent = React.lazy(() =>
  import("./components/Datasets/AllDataSets/AllDatasetsOverview")
);

const BIIndividualPage = React.lazy(() =>
  import("./components/BiCatalogue/IndividualReport/BIIndividualData")
);

const DomainDetails = React.lazy(() =>
  import("./utils/ReUsableComponents/CatalogContent")
);

const SchemaDetails = React.lazy(() =>
  import(
    "./components/Datasets/AllDataSets/Individual/SchemaWidget/IndividualSchemaOverview"
  )
);

const ViewAllDatasets = React.lazy(() =>
  import("./components/Datasets/DatasetMainPage")
);

const ViewAllReports = React.lazy(() =>
  import("./components/BiCatalogue/ViewAllReport/AllReportsPage")
);

const ViewAllSchemas = React.lazy(() =>
  import(
    "./components/Datasets/AllDataSets/Individual/SchemaWidget/SchemaViewAllPage"
  )
);
const ViewAllJobs = React.lazy(() =>
  import("./components/JobCatalogue/ViewAllJobsPage")
);

const DataCatalogueLandingPage = React.lazy(() =>
  import("./components/DataCatalogue/DataCatalogueLanding")
);

const BiCatalogueLandingPage = React.lazy(() =>
  import("./components/BiCatalogue/BiCatalogueLanding")
);
const ObservabilityMetricsPage = React.lazy(() =>
  import("./components/ObservabilityMetrics/ObservabilityMetrics")
);
const Clarity = React.lazy(() => import("./components/Clarity/Clarity"));
const ReleasePage = React.lazy(() =>
  import("./components/ReleasePage/ReleasePage")
);
const SupportServicePage = React.lazy(() =>
  import("./components/SupportServices")
);

const MyConnections = React.lazy(() =>
  import("./components/Govern/MyConnections/MyConnections")
);
const TagsClassificationGlossary = React.lazy(() =>
  import("./components/Govern/TagsClassificationGlossary")
);
// const TagsClassification = React.lazy(() =>
//   import("./components/Govern/TagsClassification/TagsClassificationData")
// );
// const GlossaryClassification = React.lazy(() =>
//   import("./components/Govern/Glossary/GlossaryDataFetchMethods")
// );
const BulkTemplate = React.lazy(() =>
  import("./components/Datasets/BulkDataUploadDownload/BulkView")
);
const DataAssistant = React.lazy(() =>
  import("./components/DataAssistant/comingsoon")
);
const NewDataSourceConnection = React.lazy(() =>
  import("./components/NewDataSourceConnection/NewDataSourceConnection")
);
const MetadataCrawl = React.lazy(() =>
  import("./components/MetaDataCrawl/MetadataCrawl")
);
const ConnectionDetail = React.lazy(() =>
  import("./components/Govern/MyConnections/ConnectionDetail")
);
const MetricStoreSearchLanding = React.lazy(() =>
  import("./components/metricstore/MetricStoreSearchLanding")
);
const UserObservabilityMetrics = React.lazy(() =>
  import("./components/ObservabilityMetrics/UserObservabilityMetrics")
);
const routes = [
  // {
  //   path: "/databook/landing",
  //   exact: true,
  //   name: "Databook Landing Page",
  //   component: <LandingPageContent />,
  // },

  // {
  //   path: "/databook/viewalldatasets",
  //   exact: true,
  //   name: "Databook Datasets View All Page",
  //   component: <ViewAllDatasets />,
  // },
  // UserObservabilityMetrics
  {
    path: "/databook/notauthorised",
    exact: true,
    name: "Databook Reports View All Page",
    component: <NotAuthorized />,
  },
  {
    path: "/databook/observability/info",
    exact: true,
    name: "Databook Reports View All Page",
    component: <UserObservabilityMetrics />,
  },
  {
    path: "/databook/metricCatalog/:search",
    exact: true,
    name: "Databook Reports View All Page",
    component: <MetricStoreSearchLanding />,
  },
  {
    path: "/databook/viewallreports",
    exact: true,
    name: "Databook Reports View All Page",
    component: <ViewAllReports />,
  },
  {
    path: "/databook/viewallschemas",
    exact: true,
    name: "Databook Schema View All Page",
    component: <ViewAllSchemas />,
  },
  {
    path: "/databook/viewalljobs",
    exact: true,
    name: "Databook Job Catalogue View All Page",
    component: <ViewAllJobs />,
  },
  {
    path: "/databook/viewallreports/:searchparam",
    exact: true,
    name: "Databook Reports View All Page",
    component: <ViewAllReports />,
  },
  {
    // path: "/databook/viewalldatasets/:searchparam",
    path: "/databook/viewalldatasets",
    exact: true,
    name: "Databook Datasets View All Page",
    // component: <ViewAllDatasets />,
    // component: <DomainDetails />,
    component: <CatalogContent />,



  },
  {
    path: "/databook/datasets",
    exact: true,
    name: "Databook Datasets Page",
    component: <DatasetsPageContent />
  },
  {
    path: "/databook/datasets/alldatasets/:id",
    exact: true,
    name: "Databook All Datasets",
    component: <IndividualPage />,
  },
  {
    path: "/databook/job/:id",
    exact: true,
    name: "Databook Jobs",
    component: <JobIndividualPage />,
  },
  {
    path: "/databook/datasets/recentlyadded/:id",
    exact: true,
    name: "Databook Recently added Datasets",
    component: <IndividualPage />,
  },
  {
    path: "/databook/datasets/frequentlyaccessed/:id",
    exact: true,
    name: "Databook Frequently Accessed Datasets",
    component: <IndividualPage />,
  },
  {
    path: "/databook/datasets/troublesome/:id",
    exact: true,
    name: "Databook Troublesome Datasets ",
    component: <IndividualPage />,
  },
  {
    path: "/databook/datasets/alldatasets/:id",
    exact: true,
    name: "Databook All Datasets",
    component: <IndividualPage />,
  },
  {
    path: "/databook/bicatalog/dashboard/:fqn",
    exact: true,
    name: "Databook BI Catalogue",
    component: <BIIndividualPage />,
  },

  {
    path: "/databook/:category/:value",
    name: "Data Catalogue",
    exact: true,
    component: <DomainDetails />,
  },
  {
    path: "/databook/metric-catalog/:category/:value",
    name: "Metric Catalogue",
    exact: true,
    component: <MetricStoreSearchLanding />,
  },
  {
    path: "/databook/metric-catalog/",
    name: "Metric Catalogue",
    exact: true,
    component: <MetricStoreSearchLanding />,
  },

  {
    path: "/databook/schema/:category/:value",
    name: "Data Catalogue",
    exact: true,
    component: <SchemaDetails />,
  },
  {
    path: "/databook/datacatalogue",
    name: "Data Catalogue",
    exact: true,
    component: <DataCatalogueLanding />,
  },
  {
    path: "/databook/bicatalogue",
    name: "Data Catalogue",
    exact: true,
    component: <BiCatalogueLandingPage />,
  },
  {
    path: "/databook/observabilitymetrics",
    name: "Observability Metrics",
    exact: true,
    component: <ObservabilityMetricsPage />,
  },
  {
    path: "/databook/clarity",
    name: "Clarity",
    exact: true,
    component: <Clarity />,
  },
  {
    path: "/databook/release",
    name: "Release",
    exact: true,
    component: <ReleasePage />,
  },
  {
    path: "/databook/supportservice",
    name: "Support Service",
    exact: true,
    component: <SupportServicePage />,
  },
  {
    path: "/databook/myconnections",
    name: "My Connections",
    exact: true,
    component: <MyConnections />,
  },
  {
    path: "/databook/PublishLineage",
    name: "Publish Lineage",
    exact: true,
    component: <PublishLineage />,
  },
  {
    path: "/databook/connectiondetail/:connfqn",
    name: "My Connections details",
    exact: true,
    component: <ConnectionDetail />,
  },
  {
    path: "/databook/tagsclassifcation",
    name: "Tags Claasification",
    exact: true,
    // component: <TagsClassification />,
    component: <TagsClassificationGlossary />,
  },
  // {
  //   path: "/databook/glossary",
  //   name: "Glossary Classification",
  //   exact: true,
  //   // component: <GlossaryClassification />,
  //   component: <TagsClassificationGlossary />,
  // },
  {
    path: "/databook/bulkupload",
    name: "Bulk Upload",
    exact: true,
    component: <BulkTemplate />,
  },
  {
    path: "/databook/createDataSources",
    name: "New DataSource Connection",
    exact: true,
    component: <NewDataSourceConnection />,
  },
  {
    path: "/databook/createDataSources/:connection_id",
    name: "Edit DataSource Connection",
    exact: true,
    component: <NewDataSourceConnection />,
  },
  {
    // path: "/databook/metadataCrawl/:connectionFqnValue",
    path: "/databook/metadatacrawl/:connectionFqnValue",
    name: "MetaData Crawl",
    exact: true,
    component: <MetadataCrawl />,
  },
  {
    path: "/databook/publishMetadata",
    name: "Publish Metadata",
    exact: true,
    component: <MetadataCrawl />,
  },
  {
    path: "/databook/publishMetadata/:connectionFqn",
    name: "Publish Metadata",
    exact: true,
    component: <MetadataCrawl />,
  },
  {
    path: "/databook/addNewLineage",
    name: "Add New Lineage",
    exact: true,
    component: <AddNewLineage />,
  },
  {
    path: "/databook/dataassistant",
    name: "Data Assistant",
    exact: true,
    component: <DataAssistant />,
  },
  {
    path: "/databook/datasets/alldatasets/metric/:id",
    name: "Metric Details",
    exact: true,
    component: <MetricDetailsPage />,
  },
];

export default routes;
